module.exports = __webpack_public_path__ + "static/media/filterIcon.95e291e3.svg";